module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Urgent-mail-d11f0ba4a1e3c1c28f8d4073abc33796.svg";